/*
| Developed by Dirupt
| Filename : container.ts
| Author : Philippe DESPLATS (philippe@dirupt.com)
*/

/*
|--------------------------------------------------------------------------
| Contracts
|--------------------------------------------------------------------------
*/
export interface VariantContainerProps {
	staggerIn?: number
	delayIn?: number
	staggerOut?: number
}

/*
|--------------------------------------------------------------------------
| Variant - Container
|--------------------------------------------------------------------------
*/
export const variantContainer = (props?: VariantContainerProps) => {
	const staggerIn = props?.staggerIn || 0.05
	const delayIn = props?.staggerIn || 0.05
	const staggerOut = props?.staggerIn || 0.05

	return {
		animate: {
			transition: {
				staggerChildren: staggerIn,
				delayChildren: delayIn,
			},
		},
		exit: {
			transition: {
				staggerChildren: staggerOut,
				staggerDirection: -1,
			},
		},
	}
}
